export default __webpack_public_path__ + "static/media/screen1.b1fceec6.png";